var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedsafLogoGreenWithoutText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 56,
    viewBox: "0 0 52 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5419 18.0835H4.05221C1.81435 18.0835 0 19.9814 0 22.3228V33.3896C0 35.7305 1.81435 37.6289 4.05221 37.6289H14.4653C17.0743 29.7774 16.0012 22.7562 14.5419 18.0835Z",
    fill: "#288A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9478 18.0831H43.6229C29.3405 24.7846 24.9186 32.3001 20.6341 39.5898C19.3985 41.6912 18.142 43.8216 16.6585 45.924V50.8144C16.6585 53.1553 18.4714 55.0527 20.7097 55.0527H31.2892C33.5276 55.0527 35.3414 53.1553 35.3414 50.8144V37.6285H47.9478C50.1856 37.6285 52 35.7301 52 33.3892V22.3224C52 19.981 50.1856 18.0831 47.9478 18.0831Z",
    fill: "#288A3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5363 11.0826C13.5363 11.0826 27.0901 32.3499 6.75873 53.3213C22.8545 41.8019 17.2067 26.4425 47.421 14.3319C29.3488 16.6947 20.8772 15.5128 13.5363 11.0826Z",
    fill: "#33869D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5407 11.5142C25.1704 11.5142 23.2493 9.50461 23.2493 7.02464C23.2493 4.54569 25.1704 2.53563 27.5407 2.53563C29.911 2.53563 31.832 4.54569 31.832 7.02464C31.832 9.50461 29.911 11.5142 27.5407 11.5142ZM31.2892 0.65802H20.7097C18.4713 0.65802 16.6584 2.55592 16.6584 4.89684V10.5886C20.9314 12.6702 25.6904 13.5811 32.0562 13.5811C33.0972 13.5811 34.1912 13.5562 35.3414 13.5065V4.89684C35.3414 2.55592 33.5275 0.65802 31.2892 0.65802Z",
    fill: "#288A3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedsafLogoGreenWithoutText);
export default __webpack_public_path__ + "static/media/medsafLogoGreenWithoutText.399f743cd4e62bd3e861056afa235990.svg";
export { ForwardRef as ReactComponent };